/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1Notification } from '../models/V1Notification';
import { HttpFile } from '../http/http';

export class V1GetNotificationsResponse {
    'notifications'?: Array<V1Notification>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "notifications",
            "baseName": "notifications",
            "type": "Array<V1Notification>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1GetNotificationsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

